import { MenuItem, Select, SelectChangeEvent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import React from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const ManageActivityLogs = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [UserRole, setUserRole] = React.useState('default');
  const handleUserRoleChange = (event: SelectChangeEvent) => {
    setUserRole(event.target.value as string);
  };
  const [ActionType, setActionType] = React.useState('default');
  const handleActionTypeChange = (event: SelectChangeEvent) => {
    setActionType(event.target.value as string);
  };

  const [rows] = useState([
    {
      id: 1,
      datetime: "04-Sep-2025 10:25 AM",
      actor: "John Doe",
      actorEmail: "johndoe@yopmail.com",
      role: "Superadmin",
      action: "Deleted Promotion",
      summary: "Promotion #234 removed from list",

    },
    {
      id: 2,
      datetime: "04-Sep-2025 09:50 AM",
      actor: "John Doe",
      actorEmail: "johndoe@yopmail.com",
      role: "Customer",
      action: "Updated Profile",
      summary: "Customer #132 updated their profile photo",
    
    },
    {
      id: 3,
      datetime: "04-Sep-2025 09:30 AM",
      actor: "John Doe",
      actorEmail: "johndoe@yopmail.com",
      role: "Admin",
      action: "Login",
      summary: "Admin John logged in successfully",
     
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Activity Log</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Activity Log
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
            <div className="form">
              <Select
                fullWidth
                value={UserRole}
                onChange={handleUserRoleChange} >
                <MenuItem disabled value="default">User Role</MenuItem>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Admin">Admin</MenuItem>
                <MenuItem value="Subadmin">Subadmin</MenuItem>
                <MenuItem value="Vendor">Vendor</MenuItem>
                <MenuItem value="Customer">Customer</MenuItem>
              </Select>
              <Select
                fullWidth
                value={ActionType}
                onChange={handleActionTypeChange} >
                <MenuItem disabled value="default">Action Type</MenuItem>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Login">Login</MenuItem>
                <MenuItem value="Create">Create</MenuItem>
                <MenuItem value="Update">Update</MenuItem>
                <MenuItem value="Delete">Delete</MenuItem>
                <MenuItem value="Payment">Payment</MenuItem>
              </Select>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="Pick date" />,
                  }}
                  slotProps={{
                    textField: {
                      id: "dob",
                      placeholder: "Select Date",
                      fullWidth: true,
                      hiddenLabel: true,
                    },
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Date/Time</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Summary</TableCell>
            
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell>{row.datetime}</TableCell>
                  <TableCell>
                    <div className="user_block">
                      <p>
                        <b>{row.actor}</b>
                        <span>{row.actorEmail}</span>
                      </p>
                    </div>
                  </TableCell>
                  <TableCell>{row.role}</TableCell>
                  <TableCell>{row.action}</TableCell>
                  <TableCell className="max_c2">{row.summary}</TableCell>
             
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManageActivityLogs;
